import Vue from 'vue'
import Vuex from 'vuex'
// import 'babel-polyfill'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { firebaseConfig } from '../config'
import user from './user'
import tabs from './tabs'
import tags from './tags'
import default_tags from './default_tags'

firebase.initializeApp(firebaseConfig)
Vue.use(Vuex)

const firestore = firebase.firestore()
// firestore.settings({ timestampsInSnapshots: true })
firestore.enablePersistence({experimentalTabSynchronization:true})
	.catch(function(err) {
			if (err.code == 'failed-precondition') {
				console.log('failed-precondition');
			} else if (err.code == 'unimplemented') {
				console.log('unimplemented');
			}
	});

firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  .then(function() {
		console.log('persist suc')
  })
  .catch(function(error) {
    console.log('persist error', error)
	});

const state = {
	db: firestore
}

const mutations = {
	
}
export default new Vuex.Store({
	state,
	mutations,
	modules: {
		user,
		tabs,
		tags,
		default_tags
	}
})
